import { render } from "./GlobalNews.vue?vue&type=template&id=6b8090d0&scoped=true"
import script from "./GlobalNews.vue?vue&type=script&lang=js"
export * from "./GlobalNews.vue?vue&type=script&lang=js"

import "./GlobalNews.vue?vue&type=style&index=0&id=6b8090d0&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8090d0"]])

export default __exports__